import React from 'react';
import { IInput } from '../../interfaces/Input.interface';
import {
  StyledInput,
  Container,
  Label,
  InputContainer,
  SubLabelText,
  Error,
  CheckMarkContainer,
  ComponentTooltip,
  MessageTooltipText,
  LoaderContent
} from './styles';
import { Checkmark } from './assets/Checkmark';

const MaskedInput: React.FC<IInput> = ({
  haserror,
  isDisabled,
  label,
  mask,
  name,
  onBlur,
  onChange,
  subLabel,
  externalError,
  hasCheckmark = false,
  type,
  value,
  defaultValue,
  error = {},
  tooltip,
  maskChar,
  loader,
  isfocused,
  inputModeProp,
  ...rest
}: IInput) => {
  return (
    <Container>
      <Label htmlFor={name} haserror={error[name] || externalError} isfocused={isfocused} isDisabled={isDisabled}>
        {label}
      </Label>

      {!!subLabel && (
        <SubLabelText>
          {subLabel}
          {!!tooltip && (
            <ComponentTooltip>
              {tooltip.icon}
              <MessageTooltipText>{tooltip.message}</MessageTooltipText>
            </ComponentTooltip>
          )}
        </SubLabelText>
      )}

      <InputContainer>
        {!!error[name] && <Error title={error[name]}>{error[name]}</Error>}
        {!!externalError && <Error title={externalError}>{externalError}</Error>}
        <StyledInput
          mask={mask}
          value={value}
          defaultValue={defaultValue}
          autoComplete="nope"
          onBlur={onBlur}
          onChange={onChange}
          name={name}
          type={type}
          disabled={isDisabled}
          maskChar={maskChar}
          haserror={error[name] || externalError}
          isfocused={isfocused}
          inputMode={inputModeProp}
          {...rest}
        />
      </InputContainer>

      {hasCheckmark && !!value && !isfocused && !!!error[name] && (
        <CheckMarkContainer>
          <Checkmark />
        </CheckMarkContainer>
      )}
      {!!loader && <LoaderContent>{loader}</LoaderContent>}
    </Container>
  );
};

export default MaskedInput;
